<h3>{{ I18ns.home.subtitle }}</h3>

<div [routerLink]="['/add-theme']" class="btn add-button">{{ I18ns.home.create }}</div>

<app-themes></app-themes>
